import { defineComponent } from 'vue'
import type { ExtractPropTypes } from 'vue'
import { ElButton } from 'element-plus'


export const querytableCellButtonProps = () => ({
  type: String,
})

export type QuerytableCellButtonProps = Partial<ExtractPropTypes<ReturnType<typeof querytableCellButtonProps>>>

export default defineComponent({
  name: 'OQuerytableCellButton',
  inheritAttrs: false,
  props: querytableCellButtonProps(),
  emits: ['click'],
  setup(props, { slots, attrs, emit, expose }) {
    const handleClick = (event: Event) => {
      emit('click', event)
    }

    return () => {
      const { type } = props
      const children = slots.default?.()

      return (
        <ElButton link type={type} size="small" onClick={handleClick}>
          {children}
        </ElButton>
      )
    }
  },
})
